import { Alert, Box, Stack, Typography } from "@mui/material";

import { PortalEmailAvailabilityResponse } from "@/api";
import { ClientLink } from "@/common/components/client-link/ClientLink";
import { ClientMasterDataTab } from "@/router/ClientRoutes";
import { Trans, useTranslation } from "@/translations";

interface Props {
  email: string;
  availability: PortalEmailAvailabilityResponse;
}

export function PortalEmailDuplicateHint({ email, availability }: Props) {
  const { t } = useTranslation();

  return (
    <Alert severity="error" icon={false} sx={{ width: "100%", maxWidth: 620 }}>
      <Stack spacing={0.5}>
        <Typography variant="body2">
          <Trans
            i18nKey="clientAccess.invitation.duplicateTitle"
            values={{ email }}
            components={{
              // The address is rendered the same way as in the status card above.
              email: <Box component="span" sx={{ fontFamily: "monospace", fontWeight: "bold" }} />,
            }}
          />
        </Typography>

        {availability.linkedClientId && (
          <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
            <Typography variant="body2">{t("clientAccess.invitation.duplicateLinkedTo")}</Typography>
            <ClientLink
              clientId={availability.linkedClientId}
              name={`${availability.linkedClientName} (${availability.linkedCaseNumber})`}
              variant="body2"
              masterDataTab={ClientMasterDataTab.ClientAccess}
            />
          </Stack>
        )}
      </Stack>
    </Alert>
  );
}
